const focus = {
  name: 'focus',
  hooks: {
    inserted(el: { focus: () => void }) {
      el.focus();
    },
  },
};

export default focus;
